import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import magnifierImg from "src/img/magnifier.png";
import Resize from "src/components/common/resize";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    boolAndReducer, myAxios, 
    mimeTypeMap, arrayReducer,
    MyFormData,
    objDescSort,
    onlyUnique,
    appTitle
} from "src/components/common/functions";
import FilterForm from "./filter";
import Export from "./export";
//--------------------------------------------------------------------------------------------
const requiredFormsObj = {
    "PreVehicleForm": "Pre-Vehicle Form", 
    "PostVehicleForm": "Post-Vehicle Form", 
    "PreTrailerForm": "Pre-Trailer Form", 
    "PostTrailerForm": "Post-Trailer Form"
};
const noFormNeeded = ["PreVehicleForm", "PostVehicleForm", "PreTrailerForm", "PostTrailerForm"];
const statusNeeded = ["Incident Report", "Equipment Damage Report", "Good Catch Form", "Near Miss Form", "Sacramento Vacuum Field Survey", "Weekly Maintenance Zerk Fittings"];
const truckNeeded = ["Equipment Damage Report", "Weekly Maintenance Zerk Fittings"];
const noWorkLogs = ["JSA", "Multi Site JSA"];
export default function ProjectForms({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const history = useHistory();
    //------------------------------------------------------
    const [filterWords, setFilterWords] = useState("");
    const defaultFilter = {
        projectName: "", 
        category: "", 
        laborCategory: "",
        laborName: "",
        department: "",
        workLogSubmitTimeMin: "",
        workLogSubmitTimeMax: "",
    };
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showFilter, setShowFilterForm] = useState(false);
    //------------------------------------------------------
    const [archive, setArchive] = useState(false);
    const [formType, setFormType] = useState("");
    const [truckNumber, setTruckNumber] = useState("");
    const [currentData, setCurrentData] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const indexOfLastProject = currentPage * itemsPerPage;
    const indexOfFirstProject = indexOfLastProject - itemsPerPage;
    const plannedTimeExcel = (start, end, allDay) => {
        if(start.substring(0, 10) === end.substring(0, 10)){
            //same Day
            if(allDay){
                return {"richText": [
                    {"font": {"bold": true},"text": start.substring(0, 10)}
                ]};
            }else{
                return {"richText": [
                    {"font": {"bold": true},"text": start.substring(0, 10)},
                    {"text": start.substring(10, 16) + " ~ " + end.substring(11, 16)}
                ]};
            }
        }else{
            //overnight
            if(allDay){
                return {"richText": [
                    {"font": {"bold": true},"text": start.substring(0, 10)},
                    {"text": " ~ "},
                    {"font": {"bold": true},"text": end.substring(0, 10)},
                ]};
            }else{
                return {"richText": [
                    {"font": {"bold": true},"text": start.substring(0, 16)},
                    {"text": " ~ "},
                    {"font": {"bold": true},"text": end.substring(0, 16)},
                ]};
            }
        }
    }
    const workLogSubmitTimeExcel = e => {
        return {"richText": [
            {"font": {"bold": true},"text": e?.split(" ")[0] ?? ""},
            {"text": " " + e?.split(" ")[1] ?? ""}
        ]};
    }
    const filterData = currentData.filter(u => 
        (formType?formType === u.form:true) &&
        (curFilter.projectName?u.projectName === curFilter.projectName:true)
        && (curFilter.category?u.category === curFilter.category:true)
        && (curFilter.laborName?u.laborName === curFilter.laborName:true)
        && (curFilter.laborCategory?u.laborCategory === curFilter.laborCategory:true)
        && (curFilter.department?u.department === curFilter.department:true)
        && (curFilter.workLogSubmitTimeMin?u.workLogSubmitTime >= curFilter.workLogSubmitTimeMin:true)
        && (curFilter.workLogSubmitTimeMax?u.workLogSubmitTime <= curFilter.workLogSubmitTimeMax:true)
        && (curFilter.startMin?u.startTime >= curFilter.startMin:true)
        && (curFilter.startMax?u.startTime <= curFilter.startMax:true)
        && (curFilter.endMin?u.endTime >= curFilter.endMin:true)
        && (curFilter.endMax?u.endTime <= curFilter.endMax:true)
        && (truckNumber?u.truckNumber === truckNumber:true)
        && (archive?u.status === "Completed":u.status !== "Completed")
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    ).sort((a, b) => objDescSort(a, b, "formSubmitTime"));
    const currentPageProjects = filterData.slice(indexOfFirstProject, indexOfLastProject);
    const pageNumbers = Array.from({length: Math.ceil(filterData.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const statusColorCode = status => {
        switch (status) {
            case "Completed":
                return "green";
            case "In Progress":
                return "purple";
            default:
                break;
        }
    }
    const getData = async () => {
        const formData = new MyFormData();
        formData.append("formType", formType);
        //-------------------------------
        setShowLoading(true);
        const res = await myAxios("approvals/readProjectsForms.php", formData);
        setShowLoading(false);
        if(!res) return;
        let data = res.data;
        if(formType === "Potholing Form"){
            data = data
            .map((project => ({
                ...project, 
                laborName: project.laborName?.replace(/ {2}/g, " "),
                forms: JSON.parse(project.potholingForm ?? "[]"),
                form: "Potholing Form"
            })))
            .map(project => project.forms.map(f => ({
                ...project, 
                ...f, 
                formSubmitTime: f.potholingFormSubmitTime
            })))
            .reduce(arrayReducer, []);
        }else if(formType === "Multi Site JSA"){
            data = data
            .map((project => ({
                ...project, 
                laborName: "",
                forms: JSON.parse(project.multiJSA ?? "[]"),
                form: "Multi Site JSA"
            })))
            .map(project => project.forms.map(f => ({
                ...project, 
                ...f, 
                id: f.jobSafetyAnalysisTemplate, 
                content: JSON.stringify(f.content)
            })))
            .reduce(arrayReducer, []);
        }else if(formType === "JSA"){
            data = data
            .map(wi => ({
                ...wi, 
                laborName: "", 
                formSubmitTime: wi.startTime, 
                id: wi.jobSafetyAnalysisTemplate, 
                form: "JSA"
            }));
        }else if(Object.keys(requiredFormsObj).includes(formType)){
            const prePost = formType.slice(0, 3) === "Pre"?"pre":"post";
            data = data
            .map(project => ({
                ...project,  
                formSubmitTime: project[`${prePost}DriverSubmitTime`], 
                id: "", 
                form: formType
            }));
        }else{
            data = data
            .map((project => ({
                ...project, 
                laborName: project.laborName?.replace(/ {2}/g, " "),
                forms: JSON.parse(project.forms ?? "[]")
            })))
            .map(project => project.forms.map(f => ({
                ...project, 
                ...f
            })))
            .reduce(arrayReducer, []);
        }
        setCurrentData(
            data
            .sort((a, b) => objDescSort(a, b, "formSubmitTime"))
            .map(u => ({
                ...u, 
                plannedTimeExcel: plannedTimeExcel(u.startTime, u.endTime, u.allDay), 
                workLogSubmitTimeExcel: workLogSubmitTimeExcel(u.workLogSubmitTime),
                truckNumber: JSON.parse(u.content || "{}")["Truck Number"],
                status: JSON.parse(u.content || "{}")["Approval Notes"]?"Completed":JSON.parse(u.content || "{}")["Action Status"] ?? ""
            }))
        );
    }
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
            <div className = "cssTab">
            <div  className = "cssHeader" style = {{background: user.userTheme}}>
                <span><Resize/>Projects Forms</span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "formType" className = "mb-0">
                        Form Type:
                    </label>
                    <select
                        id = "formType"
                        className = "form-control w-auto ml-2"
                        value = {formType}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            setFormType(value);
                            setTruckNumber("");
                            setCurrentPage(1);
                        }}
                    >
                        <option value = "">Select</option>
                        {/*-----------------------------------*/}
                        <option>Incident Report</option>
                        <option>Equipment Damage Report</option>
                        <option>Good Catch Form</option>
                        <option>Near Miss Form</option>
                        <option>Sacramento Vacuum Field Survey</option>
                        <option>Weekly Maintenance Zerk Fittings</option>
                        {/*-----------------------------------*/}
                        <option>Potholing Form</option>
                        <option>Manhole Form</option>
                        <option>Electric Pothole Form</option>
                        <option>GPR Form</option>
                        <option>Locating Form</option>
                        <option>Gas Leak Survey</option>
                        <option>Multi Site JSA</option>
                        <option>JSA</option>
                        <option value = "PreVehicleForm">Pre-Vehicle Form</option>
                        <option value = "PostVehicleForm">Post-Vehicle Form</option>
                        <option value = "PreTrailerForm">Pre-Trailer Form</option>
                        <option value = "PostTrailerForm">Post-Trailer Form</option>
                        {/*-----------------------------------*/}
                    </select>
                </span>
                {truckNeeded.includes(formType)?
                <span className = "d-flex align-items-center">
                <label htmlFor = "truckNumber" className = "mb-0">Truck:</label>
                <select
                    id = "truckNumber"
                    className = "form-control w-auto ml-2"
                    value = {truckNumber} 
                    onChange = {e => {
                        setTruckNumber(e.currentTarget.value);
                        setCurrentPage(1);
                    }}
                >
                    <option value = "">Select</option>
                    {currentData.map(data => data.truckNumber).filter(onlyUnique).map(t => <option>{t}</option>)}
                </select>
                </span>
                :<></>}
                <span className = "pointer" onClick = {getData}>Search</span>
                <span className = "pointer rounded p-1" style = {{
                    backgroundColor: Object.entries(curFilter).filter(([key, value]) => defaultFilter[key] !== value).length?
                    "rgb(0,123,255)"
                    :null
                }} onClick = {() => {setShowFilterForm(true)}}>
                    Filter
                </span>
                {showFilter?
                <FilterForm 
                    // setCurrentPage = {setCurrentPage}
                    setCurrentProjectPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    closeIt = {() => setShowFilterForm(false)}
                    defaultFilter = {defaultFilter}
                    currentData = {currentData}
                />:null}
                <span className = "pointer rounded p-1" style = {{
                    backgroundColor: archive?
                    "rgb(0,123,255)"
                    :null
                }} onClick = {() => setArchive(archive => !archive)}>Archive</span>
                <Export
                    filterData = {filterData}
                    formType = {formType}
                />
            </div>
            <div className = "cssContent pb10">
            {showLoading?<div className = "cssLoading">Loading...</div>:
            !filterData.length?<div className = "cssLoading">Empty</div>:
            <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Project Name</th>
                            <th>Project Category</th>
                            {noWorkLogs?<>
                            <th>Start Time</th>
                            </>:<>
                            <th>Labor Category</th>
                            <th>Technician</th>
                            <th>Department</th>
                            <th>Submit Time</th>
                            </>}
                            <th>Form Type</th>
                            {truckNeeded.includes(formType)?
                            <th>Truck</th>
                            :<></>}
                            {statusNeeded.includes(formType)?
                            <th>Status</th>
                            :<></>}
                            {noFormNeeded.includes(formType)?<></>:
                            <th></th>
                            }
                        </tr>
                        </thead>
                        <tbody> 
                        {currentPageProjects.map((v, key) =>
                            <tr
                                key = {key}
                                className = "pointer"
                                style = {{
                                    color: statusColorCode(v.status)
                                }}
                                onClick = {e => {
                                    if(e.target.id) return;
                                    if(v.form === "JSA"){
                                        //window.alert("Select JSA manually.");
                                        history.push(`/Projects/${v.projectHashKey}/WorkInstructions/${v.workInstructionHashKey}`);
                                    }else if(v.form === "Potholing Form"){
                                        history.push(`/Projects/${v.projectHashKey}/WorkInstructions/${v.workInstructionHashKey}/WorkLogs/${v.workLogHashKey}/PotholingForm/${v.hashKey}`);
                                    }else if(Object.keys(requiredFormsObj).includes(v.form)){
                                        history.push(`/Projects/${v.projectHashKey}/WorkInstructions/${v.workInstructionHashKey}/WorkLogs/${v.workLogHashKey}/${v.form}`);
                                    }else{
                                        history.push(`/Projects/${v.projectHashKey}/WorkInstructions/${v.workInstructionHashKey}/WorkLogs/${v.workLogHashKey}/${v.hashKey}`);
                                    }
                                }}
                            >                 
                                <td>{v.projectName}</td>
                                <td>{v.category}</td>
                                {noWorkLogs?<>
                                <td>{v.allDay?v.startTime.slice(0, 10):v.startTime}</td>
                                </>:<>
                                <td>{v.laborCategory}</td>
                                <td>{v.laborName}</td>
                                <td>{v.department}</td>
                                <td>
                                    <span className = "font-weight-bold">
                                        {v.formSubmitTime?.substring(0, 10)  ?? ""}
                                    </span>
                                    {" "}
                                    {v.formSubmitTime?.substring(11, 16) ?? ""}
                                </td>
                                </>}
                                <td>
                                    {requiredFormsObj[v.form] ?? v.form}
                                </td>
                                {truckNeeded.includes(formType)?
                                <td>
                                    {v.truckNumber}
                                </td>
                                :<></>}
                                {statusNeeded.includes(formType)?
                                <td>
                                    {v.status}
                                </td>
                                :<></>}
                                {noFormNeeded.includes(formType)?<></>:
                                <td>
                                    <span
                                        id = {v.id}
                                        className = "btn btn-primary"
                                        onClick = {async() => {
                                            if(!v.id){
                                                window.alert("File Error.");
                                                return;
                                            }
                                            const formData = new MyFormData();
                                            formData.append("fileId[]", v.id);
                                            //-------------------------------
                                            setShowLoader(true);
                                            const res = await myAxios("common/getFile.php", formData, "blob");
                                            setShowLoader(false);
                                            if(!res) return;
                                            //-------------------------------
                                            const file = new Blob([res.data], {type: mimeTypeMap.pdf});
                                            saveAs(file, `${v.form} ${v.laborName} ${v.formSubmitTime}.pdf`);
                                        }}
                                    >Form</span>
                                </td>
                                }
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>}
            {!showLoading && filterData.length?
            <Footer
                length = {filterData.length}
                pageNumbers = {pageNumbers}

                currentPage = {currentPage}
                setCurrentPage = {setCurrentPage}
                itemsPerPage = {itemsPerPage}
                setItemsPerPage = {setItemsPerPage}
            />
            :null}
            </div>
        </div>
    )
}